<div style="margin-top: 30px; margin-bottom: 30px;">
  <div class="zaya-form-help-text" *ngIf="results.length === 0 && resultsLoaded">
    <span style="font-size: 20px;">Sorry we couldn't find any matches for that.</span> <br>
    <a href="http://www.zayamed.com/contact-us" target="_blank">Can't find a practitioner? Contact us and we will do our best to connect you to the best practitioner.</a>
  </div>
  <app-practitioner-list-item
    *ngFor="let result of results"
    [practitioner]="result.practitioner"
    [distance]="result.getDistance(false)"
    [matchedTerms]="result.matches"
    [active]="selectedPractitioner === result.practitioner.id"></app-practitioner-list-item>
</div>
